import PhysicalVerificationMonitor from 'ui-component/cards/PhysicalVerification/PhysicalVerificationMonitor';

const NHPVMonitorPage = () => {
    return <PhysicalVerificationMonitor />;
};

export default NHPVMonitorPage;
